const privacyPolicyUpdatedAt = "07/05/2025";

export const NeighborwhoodPrivacyPolicy = () => {
  return (
    <div>
      <h3>Privacy Policy for NeighborWhood mobile application</h3>
      <br />
      Last updated: <b>{privacyPolicyUpdatedAt}</b>
      <br />
      <br />
      <p>
        <b>Essencebit SRL</b> (<b>“us”</b>, <b>“we”</b>, or <b>“our”</b>)
        operates the <b>NeighborWhood</b> mobile application (<b>“App”</b>).
        <br />
        This page informs you of our policies regarding the collection, use and
        share of personal data when you use our App and the choices you have
        associated with that data.
        <br />
        <br /> Information Collection, Use and Share:
        <br />
        <b>- Data Collection:</b> We collect the following data from the users
        of our App:
        <br />- Photos
        <br />
        - Birth Date
        <br />
        - Gender
        <br />
        - Instagram Nickname
        <br />
        - Geolocation (only if the user shares it voluntarily)
        <br />
        <br />
        <b>- Data Use:</b> We use the following data from the users of our App:
        <br />- Photos (one (of maximum 3) used as <b>Profile Picture</b>, the
        rest are used as <b>Profile Photos</b>)
        <br />
        - Birth Date (used for filtering of met users)
        <br />
        - Gender (used for filtering of met users)
        <br />
        - Instagram Nickname (used for mutual sharing of it with the connected
        users)
        <br />
        - Geolocation (used for linking the users depending on the neighborhood
        radius)
        <br />
        <br />
        <b>- Data Share:</b> We do not share any data from the users of our App
        to any 3rd party.
        <br />
        <br />
        <b>- Contact Us:</b> If you have any questions about this{" "}
        <b>Privacy Policy</b>, please contact us at{" "}
        <a href="/">{window.location.origin}</a> by using the chatbot or by
        using the means from <b>"Contact Us"</b> section.
        <br />
        <br />
        <b>- Privacy Policy Changes:</b> We may update our <b>Privacy Policy</b>{" "}
        from time to time. You are advised to review this <b>Privacy Policy</b>{" "}
        periodically for any changes. This <b>Privacy Policy</b> is effective as
        of <b>{privacyPolicyUpdatedAt}</b> and will remain in effect except with
        respect to any changes in its provisions in the future, which will be in
        effect immediately after being posted on this page.
      </p>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};
